module.exports = {
  "scenes": [
    {
      "levels": [
        {
          "tileSize": 256,
          "size": 256,
          "fallbackOnly": true
        },
        {
          "tileSize": 512,
          "size": 512
        },
        {
          "tileSize": 512,
          "size": 1024
        }
      ],
      "faceSize": 2048,
      "initialViewParameters": {
        yaw: 120 * Math.PI / 180,
        pitch: -10 * Math.PI / 180,
        fov: 60 * Math.PI / 180
      }
    }
  ],
  "viewer": {
    "velocity": 0.7,
    "friction": 3,
    "autorotate": {
      "yawSpeed": 0.1,
      "targetPitch": 0,
      "targetFov": Math.PI / 2
    },
    "multiImgSrc": "/{z}/{f}/{y}/{x}",
    "maxFovLimit": 100*Math.PI/180,
    "autorotateIdle": 3000,
    "imagefaceSize": 4096
  }
};
